import { STATUSPAGE } from '@repo/ui';
import { AuthenticationChangePasswordUseCaseInterface } from 'domain/usecases';
import { useFormik } from 'formik';
import { notifyError, notifySuccess } from 'presentation/app/components/notify';
import { usePasswordResetFlow } from 'presentation/app/contexts/PasswordResetFlowContext';
import { useService } from 'presentation/app/hooks/useService';
import { useCallback, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import * as Yup from 'yup';

export const useSetNewPassword = () => {
  // hooks
  const navigate = useNavigate();
  const { resetFlow } = usePasswordResetFlow();
  const { authenticationService } = useService();
  const { state: flowState } = usePasswordResetFlow();

  // state
  const [loadingChangeNewPassword, setLoadingChangeNewPassword] =
    useState<STATUSPAGE>(STATUSPAGE.DONE);

  // validation
  const validationSetNewPassword = useFormik({
    enableReinitialize: true,
    initialValues: {
      password: '',
      repeatNewPassword: '',
    },
    validationSchema: Yup.object({
      password: Yup.string().nullable().required('Campo obrigatório.'),
      repeatNewPassword: Yup.string()
        .nullable()
        .required('Campo obrigatório.')
        .oneOf([Yup.ref('password'), null], 'As senhas não coincidem.'),
    }),
    onSubmit: (values) => {
      requestSetNewPassword({
        cpf: flowState.cpf!,
        newPassword: values.password,
        passwordConfirmation: values.repeatNewPassword,
      });
    },
  });

  // request
  const requestSetNewPassword = useCallback(
    (params: AuthenticationChangePasswordUseCaseInterface.Params) => {
      setLoadingChangeNewPassword(STATUSPAGE.LOADING);
      authenticationService
        .authenticationChangePassword(params)
        .then((res) => {
          resetFlow();
          navigate('/login');
          notifySuccess(res.message || 'Senha alterada com sucesso.');
        })
        .catch((error: unknown) => {
          if (error instanceof Error) {
            notifyError(
              error.message || 'Erro ao enviar código de redefinição.',
            );
          }
        })
        .finally(() => {
          setLoadingChangeNewPassword(STATUSPAGE.DONE);
        });
    },
    [authenticationService, resetFlow, navigate],
  );

  return {
    requestSetNewPassword,
    loadingChangeNewPassword,
    validationSetNewPassword,
  };
};
